import {ColDef} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import AGGridColorPickerCellRenderer from "@/components/inputs/AGGridColorPickerCellRenderer.vue";
import AGGridSuggestionProviderEditor from "@/components/inputs/AGGridSuggestionProviderEditor.vue";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class AGGridEditViewColorPickerColumn extends AbsAGGridEditViewColumn {
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    colDef.cellRenderer = AGGridColorPickerCellRenderer
    colDef.cellRendererParams = {
      handler: () => this.handler,
      columnId: this.id
    }
    if (this.handler.presenter.doesFieldHasSuggestionProvider(this.columnMetadata)) {
      colDef.cellEditor = AGGridSuggestionProviderEditor;
      colDef.cellEditorParams = {
        columnMetadata: this.columnMetadata,
        presenter: () => this.handler.presenter
      };
    }
    return [colDef];
  }
}
